import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, IsActiveMatchOptions } from '@angular/router';
import { right } from '@popperjs/core';
import { concat, forkJoin, fromEvent, map, merge, Observable, Observer } from 'rxjs';
import { AuthService, FundsPortalService, LoaderService, LocalStorageService } from 'src/app/core/core.module';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';

@Component({
  selector: 'app-client-onboarding',
  templateUrl: './client-onboarding.component.html',
  styleUrls: ['./client-onboarding.component.less']
})
export class ClientOnboardingComponent implements OnInit {
  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;
  public attachmentFileTypeSupported: string[] = ['JPEG', 'JPG', 'PNG', 'PDF', 'XLS', 'XLSX', 'CSV'];
  public attachmentFileMaxSizeInMD: number = 15;
  public byteToMB: number = 1048576;

  public attachmentFile: any;
  public attachmentFiles: Array<any> = [];
  public documentIDs: Array<any> = [];
  public successfulList: Array<any> = [];
  public unsuccessfulList: Array<any> = [];
  public attachmentFileBase64: string | undefined = '';
  public emailedDate: string = '';

  public isDone: Boolean = false;
  public isIncomplete: Boolean = false;
  public hasError: Boolean = false;
  public online: Boolean = false;

  public failCount: number = 0;
  public totalFileSize:number = 0;


  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public fundsPortalService: FundsPortalService,
    public localStorageService: LocalStorageService,
    public authService: AuthService,
    public loaderService: LoaderService
  ) { 
    this.createOnline().subscribe(isOnline => {
      this.online = isOnline;
    });
  }

  ngOnInit(): void {
    this.authService.refreshToken();
  }

  fileProcess(event: any): any {
    const fileList: FileList = event.target.files;
    var files = [];
    for(let x = 0; fileList.length > x; x++){
      const file: File = fileList[x];
      const fileName: string = file.name.substring(0, file.name.lastIndexOf('.'));
      const fileExtension: string = file.name.substring(file.name.lastIndexOf('.') + 1);
      const fileSize: number = file.size;
      let fileNotSupported: boolean = false;
      if (this.attachmentFileTypeSupported.indexOf(fileExtension.toUpperCase()) == -1) {
        this.atramModal.show();
        this.atramModal.size = 'sm';
        this.atramModal.status = 'error-upload';
        this.atramModal.headerText = 'File Selection Error';
        this.atramModal.bodyText = 'A file format you are trying to upload is not acceptible. File type accepted are the ff. <b>XLS,XLSX,JPG,JPEG,PNG, PDF,CSV</b>';
        this.atramModal.okButtonText = 'Continue';
        this.atramModal.showCancelButton = false;
        this.atramModal.showCloseButton = false;
        this.atramModal.confirmationSubject
          .subscribe((confirmation: boolean) => {
            if (confirmation) {
              // OK
            } else {
              // Cancel
            }
            this.atramModal.hide();
          });
        return;
      }

      this.totalFileSize += fileSize;
      if (this.totalFileSize > (this.attachmentFileMaxSizeInMD * this.byteToMB)) {
        this.atramModal.show();
        this.atramModal.size = 'sm';
        this.atramModal.status = 'error-upload';
        this.atramModal.headerText = 'Upload Error';
        this.atramModal.bodyText = 'Total file size of documents you selected exceeds 15MB. Please try again.';
        this.atramModal.okButtonText = 'Continue';
        this.atramModal.showCancelButton = false;
        this.atramModal.showCloseButton = false;
        this.atramModal.confirmationSubject
          .subscribe((confirmation: boolean) => {
            if (confirmation) {
              // OK
            } else {
              // Cancel
            }
            this.atramModal.hide();
          });
        return;
      }

      var sizeInMB = fileSize/this.byteToMB;
      var docType = '';

      const attachmentFile: any = {
        file_name: fileName + '.' + fileExtension,
        file_size: sizeInMB.toFixed(2) +" MB",    
        document_type: 'ONBOARDING'
      };

      files.push(attachmentFile);
      
      if(x === fileList.length -1){
        return files;
      }
    }
  }

  fileAttach(event: any): void {
    this.authService.refreshToken();
    var files = this.fileProcess(event);
    if(files.length > 1){
      for(let x = 0; files.length > x; x++){
        let file = event.target.files[x];
        let temp: number;
        if(this.attachmentFiles.length === undefined){
          temp = 0;
        }
        else{
          temp = this.attachmentFiles.length+x
        }
        let reader = new FileReader()    
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.attachmentFiles[temp]['file'] = reader.result?.toString().split(',')[1];
        };
        
        reader.onerror = function (error) {
          console.log('Error: ', error);
        }
      };
    }
    else{
      for(let x = 0; files.length > x; x++){
        let temp: number;
        if(this.attachmentFiles.length === undefined){
          temp = 0;
        }
        else{
          temp = this.attachmentFiles.length
        }
        let file = event.target.files[x];
        let reader = new FileReader()    
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.attachmentFiles[temp]['file'] = reader.result?.toString().split(',')[1];
        };
        
        reader.onerror = function (error) {
          console.log('Error: ', error);
        }
    }
  };
  this.getFileList(files)
  }

  getFileList(files: any){
    this.attachmentFiles.push(...files);
  }

  proceed(): void {
    this.authService.refreshToken();
    if (this.attachmentFiles.length <= 0) {
        return;

    }
    else{
      this.submit();
    }
  }

  createOnline() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }

  async submit() {
    this.loaderService.show();
    console.log(this.attachmentFiles)
    setTimeout(async () => { 
      for (let i = 0; i <= this.attachmentFiles.length; i++) {

        if(i !== this.attachmentFiles.length){
          await this.uploadDocument(i)
        }
        else{
          if(this.hasError && this.failCount != this.attachmentFiles.length){
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'warning';
            this.atramModal.headerText = 'Not all your files were uploaded';
            this.atramModal.bodyText = 'There have been some items that were not successfully uploaded.';
            this.atramModal.okButtonText = 'Continue';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) { 
                  // OK
                  this.isDone = true;
                  this.isIncomplete = true;
                } else {
                  // Cancel
                  return;
                }
                this.atramModal.hide();
              });
            return;
          }
  
          else if(this.hasError && this.failCount == this.attachmentFiles.length){
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error-upload';
            this.atramModal.headerText = 'Upload Unsuccessful';
            this.atramModal.bodyText = 'No files were uploaded.';
            this.atramModal.okButtonText = 'Continue';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  // OK
                  this.isDone = true;
                  this.failCount = 0;
                } else {
                  // Cancel
                  return;
                }
                this.atramModal.hide();
              });
            return;
          }
  
          else{
            this.emailDocuments();
          }
        }
      }
       }, 1500);
  }

  // async reSubmit() {
  //   this.loaderService.show();
  //   this.failCount = 0;
  //   this.unsuccessfulList = [];
  //   this.hasError = false;

  //   for (let i = 0; i <= this.unsuccessfulList.length; i++) {

  //     if(i !== this.unsuccessfulList.length){
  //       await this.reUploadDocument(i)
  //     }
  //     else{
  //       this.emailDocuments();
  //     }
  //   }
  // }

  goToForm(){
    this.router.navigateByUrl(`/create-account`, { skipLocationChange: false });
  }
  
  uploadDocument(i: number) {
    return new Promise((resolve, reject) => {
      this.fundsPortalService.postUploadDocument(this.attachmentFiles[i]).subscribe({
        next: (data:any) =>{
          resolve(data);
          this.documentIDs.push(
            {
              document_id: data['response_data']['document_id']
            }
          )
          this.successfulList.push(this.attachmentFiles[i]);
          this.attachmentFiles[i]['isSuccess'] = true;
        },
        error: error =>{
          if(!this.online){
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'internet-error';
            this.atramModal.headerText = 'No internet';
            this.atramModal.bodyText = 'Some files may have not been uploaded. You may resume when your internet connection has been restored.';
            this.atramModal.okButtonText = 'Continue';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  // OK
                  // this.attachmentFiles = this.unsuccessfulList;
                } else {
                  // Cancel
                  return;
                }
                this.atramModal.hide();
              });
          }
          else{
            this.attachmentFiles[i]['isSuccess'] = false;
            this.unsuccessfulList.push(this.attachmentFiles[i]);
            this.hasError = true;
            this.failCount++;
          }
        }
      })
    });
  }

  // reUploadDocument(i: number) {
  //   return new Promise((resolve, reject) => {
  //     this.fundsPortalService.postUploadDocument(this.unsuccessfulList[i]).subscribe({
  //       next: (data:any) =>{
  //         resolve(data);
  //         this.documentIDs.push(
  //           {
  //             document_id: data['response_data']['document_id']
  //           }
  //         )
  //         this.successfulList.push(this.unsuccessfulList[i]);
  //       },
  //       error: error =>{
  //         this.unsuccessfulList.push(this.unsuccessfulList[i]);
  //         this.hasError = true;
  //         this.failCount++;
  //         return;
  //         }
  //     })
  //   });
  // }

  emailDocuments(){
    return new Promise((resolve, reject) => {
      this.fundsPortalService.postEmailDocument(this.documentIDs).subscribe({
        next: (data:any) =>{
          resolve(data);
          this.loaderService.hide();
          this.atramModal.show();
          this.atramModal.size = 'sm';
          this.atramModal.status = 'success';
          this.atramModal.headerText = 'Upload Successful!';
          this.atramModal.bodyText = "We'll inform your ATRAM Funds partner regarding your transaction.";
          this.atramModal.okButtonText = 'CONTINUE';
          this.atramModal.showCancelButton = false;
          this.atramModal.showCloseButton = false;
          this.atramModal.confirmationSubject
            .subscribe((confirmation: boolean) => {
              if (confirmation) {
                // OK
                this.emailedDate = data['response_date'];
                this.isDone = true;
              } else {
                // Cancel
                return;
              }
              this.atramModal.hide();
            });
        },
        error: error =>{
          this.loaderService.hide();
          this.isDone = true;
          }
      })
    });
  }

  cancelAll(){
    this.atramModal.show();
    this.atramModal.size = 'xs';
    this.atramModal.status = 'warning';
    this.atramModal.headerText = 'Cancel Upload';
    this.atramModal.bodyText = 'Are you sure you want to remove all files on the list?';
    this.atramModal.okButtonText = 'Yes';
    this.atramModal.showCancelButton = false;
    this.atramModal.showCloseButton = true;
    this.atramModal.confirmationSubject
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          // OK
          this.attachmentFiles = [];
          this.totalFileSize = 0;
          this.authService.refreshToken();
        } else {
          // Cancel
          return;
        }
        this.atramModal.hide();
      });
    return;
  }

  removeFile(i:number, fileSize: number){
    this.attachmentFiles.splice(i, 1);
    this.totalFileSize -= fileSize;
    this.authService.refreshToken();
  }

  isRouterLinkActive(routerLink: string): boolean {
    const matchOptions: IsActiveMatchOptions = {
      paths: 'exact',
      matrixParams: 'exact',
      queryParams: 'subset',
      fragment: 'ignored'
  };
    return this.router.isActive(routerLink, matchOptions);
  }

  goToHome(){
    // if(this.isRouterLinkActive('file-upload/mutual-funds')){
    //   this.router.navigateByUrl(`/file-upload/mutual-funds`, { skipLocationChange: false });
    // }
    // else if(this.isRouterLinkActive('file-upload/uitf')){
    //   this.router.navigateByUrl(`/file-upload/uitf`, { skipLocationChange: false });
    // }
    this.attachmentFiles = [];
    this.successfulList = [];
    this.unsuccessfulList = [];
    this.documentIDs = [];
    this.totalFileSize = 0;
    this.isDone = false;
  }
}

